import { useCallback, useEffect, useRef, useState } from 'react'

const CHECK_INTERVAL = 60 * 1000
const GRACE_PERIOD = 5 * 60 * 1000

const useVersionCheck = () => {
  const [hasNewVersion, setHasNewVersion] = useState(false)
  const firstMismatchAt = useRef(null)

  const checkVersion = useCallback(async () => {
    const versionFileUrl = import.meta.env.VITE_VERSION_FILE_URL
    if (!versionFileUrl) return

    try {
      const response = await fetch(versionFileUrl, { cache: 'no-store' })
      const data = await response.json()

      if (data.version && data.version !== VERSION) {
        if (!firstMismatchAt.current) {
          firstMismatchAt.current = Date.now()
        }

        if (Date.now() - firstMismatchAt.current >= GRACE_PERIOD) {
          setHasNewVersion(true)
        }
      } else {
        firstMismatchAt.current = null
      }
    } catch {
      //
    }
  }, [])

  useEffect(() => {
    checkVersion()
    const interval = setInterval(checkVersion, CHECK_INTERVAL)
    return () => clearInterval(interval)
  }, [checkVersion])

  return { hasNewVersion }
}

export default useVersionCheck
